'use client'

import { Map, APIProvider as GoogleMapsProvider, Marker } from '@vis.gl/react-google-maps'

export default function GoogleMap({
  address,
  lat,
  lng,
  zoom = 14,
}: {
  address?: string
  lat: number
  lng: number
  zoom?: number
}) {
  if (!lat || !lng) {
    return null
  }

  const latLng = { lat: Number(lat), lng: Number(lng) }

  return (
    <div className="component">
      <div className="container @[0px]/single-simple:!max-w-[var(--container-s-max-w)]">
        <div className="h-[min(60vh,490px)] w-full">
          <GoogleMapsProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}>
            <Map
              defaultCenter={{ ...latLng }}
              defaultZoom={Number(zoom)}
              gestureHandling={'greedy'}
              disableDefaultUI={true}>
              <Marker position={{ ...latLng }} />
            </Map>
          </GoogleMapsProvider>
        </div>
      </div>
    </div>
  )
}
